import { Moment } from 'moment';
import { CURRENCY_LIST as DashboardCurrency } from '../../../core/constants/CurrenciesConstants';

// The level of a client I.E. Site, Multisite, Brand, Salecycle
export interface ClientLevel {
  id: string;
  level: string;
}

export interface StartAndEndTimes {
  startDate: Moment;
  endDate: Moment;
}

export enum ComparisonType {
  NONE = 'none',
  YEAR = 'year',
  PERIOD = 'period',
  CUSTOM = 'custom',
}

export enum DashboardGranularity {
  FIFTEEN_MINUTES = 'fifteen_minute',
  THIRTY_MINUTES = 'thirty_minute',
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  ALL = 'all',
}

export enum DashboardDateRange {
  TODAY = 0,
  YESTERDAY = 1,
  LAST_SEVEN_DAYS = 7,
  LAST_THIRTY_DAYS = 30,
  LAST_NINETY_DAYS = 90,
  LAST_YEAR = 365,
}

export { DashboardCurrency };

export interface DashboardGraphParameters {
  baseCurrency: DashboardCurrency;
  comparisonEnabled: boolean;
  granularity: DashboardGranularity;
  timezone: string;
}

export interface DashboardQueryParameters {
  dateRange: DashboardDateRange;
  dateRangeOffset: number;
  comparisonType?: ComparisonType;
  comparisonDateRange: DashboardDateRange;
  comparisonDateRangeOffset: number;
  filterCurrency?: DashboardCurrency;
  siteIds: string[];
}

export interface SalesTotalsResults {
  RecoveredCount: number;
  RecoveredValue: number;
  DirectCount: number;
  DirectValue: number;
}

export interface DashboardDataResults {
  salesTotals?: SalesTotalsResults;
  comparisonSalesTotals?: SalesTotalsResults;
}

export interface IGraphParams {
  comparisonEnabled: boolean;
  granularity: DashboardGranularity;
  healthMetricsEnabled: boolean;
}

export interface IDataPoint {
  lineVariation?: 'solid' | 'dashed';
  value: number;
  timestamp: string;
  comparisonValue?: number;
  comparisonTimestamp?: string;
  tooltipLabel?: string;
  tooltipValue?: string;
}

export interface ICurrencyValue {
  result?: DashboardCurrency;
}
